module.exports = __webpack_public_path__ + "img/en.23fcb47c.svg";